import _invert from "lodash-es/invert";
import _keys from "lodash-es/keys";
export var positionsMapping = {
  'top center': 'top',
  'top left': 'top-start',
  'top right': 'top-end',
  'bottom center': 'bottom',
  'bottom left': 'bottom-start',
  'bottom right': 'bottom-end',
  'right center': 'right',
  'left center': 'left'
};
export var positions = _keys(positionsMapping);
export var placementMapping = _invert(positionsMapping);


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Popup/lib/positions.js
// module id = 3307
// module chunks = 0